// src/constants/timeIntervals.js

const timeIntervals = [
  { label: '1 Minute', value: '1min' },
  { label: '5 Minutes', value: '5min' },
  { label: '15 Minutes', value: '15min' },
  { label: '30 Minutes', value: '30min' },
  { label: '60 Minutes', value: '60min' },
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly', value: 'weekly' },
  { label: 'Monthly', value: 'monthly' },
];

export default timeIntervals;
